/**
 * @warning
 * this is a quick and dirty replacement of the deprecated PopupConsent,
 * for the purpose of having a themeable version, using ui-core components
 * @todo the actual component interface needs to be refactored, based on the use cases
 * @todo Move to @axo packages, share with DebtRegistry Consent if possible
 */
import { Button } from '@axo/ui-core/components/Button';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Modal } from '@axo/ui-core/components/Modal';
import { Text } from '@axo/ui-core/components/typography';
import { Icon } from '@axo/ui-core/components/Icon';
import styles from './PopupConsentUI.module.scss';

export type PopupConsentUIProps = {
  title: string;
  partnersList?: string[];
  buttonText: string;
  onClick: () => void;
};

export const PopupConsentUI = ({
  title,
  partnersList,
  buttonText,
  onClick,
}: PopupConsentUIProps) => {
  return (
    <Modal open hasClose onClose={onClick}>
      <Modal.Header>
        <div className={styles.icon}>
          <Icon name={'users-three'} />
        </div>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      {partnersList && (
        <Stack gap={'2xs'} className={styles.consentText}>
          {partnersList.map((element, index) => (
            <Text key={index} size={'s'}>
              {element}
            </Text>
          ))}
        </Stack>
      )}

      <Modal.Actions>
        <Button onClick={onClick}>{buttonText}</Button>
      </Modal.Actions>
    </Modal>
  );
};
